import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { capitalize } from 'lodash'
import * as types from '../../../constants/types'
import LoadItem from '../MakeLoader/LoadItem'

import styles from './text.module.scss'

const Text = (props) => {
  const {
    size,
    bold,
    extraBold,
    inline,
    variation,
    font,
    color,
    value,
    margin,
    width,
    lineHeight,
    underline,
    uppercase,
    children,
    className,
    fontWeight,
    alignText,
    loading,
    onClick,
    captalize,
    ellipsis
  } = props

  const content = children || value

  if (!content) return null

  let captalizeVariation = ''

  if (color !== 'white' && variation) captalizeVariation = capitalize(variation)

  const textClass = classNames(
    styles.text,
    {
      [styles.bold]: bold,
      [styles.extraBold]: extraBold,
      [styles.inline]: inline,
      [styles[`${size}FontSize`]]: size,
      [styles[`${font}FontFamily`]]: font,
      [styles[`${color}${captalizeVariation}`]]: color,
      [styles.underline]: underline,
      [styles.clickable]: onClick,
      [styles.uppercase]: uppercase,
      [styles.ellipsis]: ellipsis
    },
    className
  )

  const textStyles = {}

  if (margin) textStyles.margin = margin
  if (lineHeight) textStyles.lineHeight = lineHeight
  if (width) textStyles.width = width
  if (fontWeight) textStyles.fontWeight = fontWeight
  if (alignText) textStyles.textAlign = alignText
  if (captalize) textStyles.textTransform = 'capitalize'

  return (
    <div
      className={textClass}
      style={textStyles}
      onClick={onClick}
      title={content}
    >
      {loading ? <LoadItem width="50px" height="15px" /> : content}
    </div>
  )
}

Text.defaultProps = {
  size: 'md',
  color: 'primary',
  variation: null,
  font: null,
  bold: null,
  extraBold: null,
  inline: false,
  value: null,
  margin: null,
  width: null,
  lineHeight: null,
  underline: false,
  uppercase: false,
  children: null,
  className: null,
  fontWeight: null,
  alignText: null,
  loading: false,
  onClick: null,
  captalize: false,
  ellipsis: false
}

Text.propTypes = {
  bold: PropTypes.bool,
  extraBold: PropTypes.bool,
  inline: PropTypes.bool,
  size: PropTypes.oneOf(types.TEXT_SIZES),
  variation: PropTypes.oneOf(types.COLOR_VARIATIONS),
  color: PropTypes.oneOf(types.COLORS),
  font: PropTypes.oneOf(types.TEXT_FONT_FAMILY),
  value: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  margin: PropTypes.string,
  width: PropTypes.string,
  lineHeight: PropTypes.string,
  underline: PropTypes.bool,
  uppercase: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  className: PropTypes.string,
  fontWeight: PropTypes.string,
  alignText: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  captalize: PropTypes.bool,
  ellipsis: PropTypes.bool
}

export default Text
